import { text } from "@fortawesome/fontawesome-svg-core";

const GoAiguaTooltip= (props: {text: String}) => {
  return <div className="go-aigua-tool-tip">{props.text}</div>;
};

export default GoAiguaTooltip;
